import { NO_PROMPT, TRUTHY_VALUE } from '../../constants/generic-form.constant';

export const setNoPrompt = (): void =>
  sessionStorage.setItem(NO_PROMPT, TRUTHY_VALUE);
